import { ISelectOption } from "@/interfaces/Select";

export const CALENDAR_VIEWS: ISelectOption<string>[] = [
  {
    label: "Vue mois",
    value: "dayGridMonth",
  },
  {
    label: "Vue semaine",
    value: "timeGridWeek",
  },
  {
    label: "Vue jour",
    value: "timeGridDay",
  },
  {
    label: "Vue liste",
    value: "listWeek",
  },
];
